import React, { useContext, useEffect } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import { UIConfig } from '../types/ui-config';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { useDyteMeeting, useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function DyteWaitingScreen({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  config,
  t,
}: {
  config?: UIConfig;
  t?: DyteI18n;
}) {
  const storeLang = useLanguage();
  t = t ?? storeLang;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const roomLeftStatus = storeStates.roomLeftState;
  const waitlistStatus = useDyteSelector((m) => m.self.waitlistStatus);
  const { meeting } = useDyteMeeting();
  const { width } = Dimensions.get('screen');
  useEffect(() => {
    const handleRoomLeft = ({ state }) => {
      if (state === 'failed') {
        setStates({
          ...storeStates,
          meeting: 'waiting',
          roomLeftState: 'disconnected',
          activeFullscreen: false,
          activeMoreMenu: false,
          activeSettings: false,
          activeSidebar: false,
          activeLeaveConfirmation: false,
          activeStageConfirmation: false,
          activeJoinStageConfirmation: false,
        });
      }
    };
    meeting.self.on('roomLeft', handleRoomLeft);
    return () => {
      meeting.self.off('roomLeft', handleRoomLeft);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.background[900],
    },
    text: {
      flexWrap: 'wrap',
      maxWidth: width * 0.9,
    },
  });
  return (
    <View style={styles.container}>
      {waitlistStatus === 'waiting' && (
        <DyteText style={styles.text}>{t('waitlist.body_text')}</DyteText>
      )}
      {waitlistStatus === 'rejected' && (
        <DyteText style={styles.text}>{t('ended.rejected')}</DyteText>
      )}
      {(waitlistStatus === 'none' || waitlistStatus === 'accepted') &&
        (roomLeftStatus === 'left' || roomLeftStatus === 'ended') && (
          <DyteText style={styles.text}>Loading...</DyteText>
        )}
      {waitlistStatus === 'none' && roomLeftStatus === 'kicked' && (
        <DyteText style={styles.text}>{t('ended.kicked')}</DyteText>
      )}
      {waitlistStatus === 'none' && roomLeftStatus === 'disconnected' && (
        <DyteText style={styles.text}>{t('ended.disconnected')}</DyteText>
      )}
    </View>
  );
}
